export default __webpack_public_path__ + "static/media/wa_Sood.07c075d5.svg";